import { render, staticRenderFns } from "./VerifyResult.vue?vue&type=template&id=7a23cc05&scoped=true"
import script from "./VerifyResult.vue?vue&type=script&lang=js"
export * from "./VerifyResult.vue?vue&type=script&lang=js"
import style0 from "./VerifyResult.vue?vue&type=style&index=0&id=7a23cc05&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a23cc05",
  null
  
)

export default component.exports